export interface KittlAiSectionType {
  id: AiGenerator;
  title: string;
  description: string;
  image: string;
  badge?: string;
}

export enum ImageGenerationModel {
  Turbo = 'turbo',
  Advanced = 'v2-0',
  FluxPro = 'flux',
  Ideogram = 'ideogram',
}

export type AdvancedImageGenerationModelType = Exclude<
  ImageGenerationModel,
  ImageGenerationModel.Turbo
>;

export const AdvancedImageGenerationModel = Object.values(
  ImageGenerationModel
).filter((model) => model !== ImageGenerationModel.Turbo);

export type AdvancedModelOptionType = {
  id: ImageGenerationModel;
  label: string;
  tooltipText: string;
};

export enum AiGenerator {
  ImageGenerator = 'imageGenerator',
  DesignGenerator = 'designGenerator',
  SetsGenerator = 'setsGenerator',
  StyleSwitch = 'styleSwitch',
}

export type SetShowExtensionFunction = (
  ...params: [true, { offsetTop: number } | null] | [false]
) => void;
